import styles from './radiobox.module.scss';

type Props = {
  handleChange: () => void;
  isChecked: boolean;
  inputName: string;
  inputValue: string;
  label: string;
  subtitle?: string;
  id?: string;
  style?: CSSStyleDeclaration;
};

const RadioboxComp = (props: Props) => (
  <div
    className={styles.radiobox}
    // @ts-expect-error - TS2322 - Type 'CSSStyleDeclaration | undefined' is not assignable to type 'CSSProperties | undefined'.
    style={props.style}
    onClick={props.handleChange}
  >
    <input
      type='radio'
      name={props.inputName}
      value={props.inputValue}
      id={props.id}
      checked={props.isChecked}
      onKeyDown={e =>
        e.key === 'Enter' || e.key === ' ' ? props.handleChange() : null
      }
      onChange={props.handleChange}
    />
    <label htmlFor={props.id}>
      <div className={styles.title}>{props.label}</div>
      {!!props.subtitle && (
        <div className={styles.subtitle}>{props.subtitle}</div>
      )}
    </label>
  </div>
);

export default RadioboxComp;
